import { Preloader } from '@hts/entities';
import { Footer, Header } from '@hts/features';
import VideoPopup from '@hts/oldStructure/components/video-popup';
import { useGetStaticElementsQuery } from '@hts/shared/api';
import { useAppSelector, useGetPageDepartment } from '@hts/shared/libs';
import { WhatsAppChat } from '@hts/widgets/whatsAppChat';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import styles from '../styles/GlobalLayout.module.scss';
import { ErrorBoundary } from './ErrorBoundary';

export const GlobalLayout = () => {
  const { isCustomMode } = useAppSelector((state) => state.mainReducer);

  const location = useLocation();

  const staticElementsQuery = useGetStaticElementsQuery({ link: '/' }, { refetchOnFocus: false });
  const { pageDepartment, dynamicElementsState } = useGetPageDepartment();

  const isUninitialized =
    staticElementsQuery.isUninitialized || dynamicElementsState.isUninitialized;
  const loading = staticElementsQuery.isLoading || dynamicElementsState.isLoading;

  useEffect(() => {
    // Scroll to top after change page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  if (isUninitialized || loading) {
    return (
      <div className={styles.preloaderContainer}>
        <Preloader />
      </div>
    );
  }

  return (
    <div
      className={`ihtsy-app ${isCustomMode ? 'custom-motion-mode' : ''} ${styles.container}`}
      data-sentry-unmask
    >
      {/* IT NEEDS FOR THE FAQ MODAL, DO NOT DELETE!!! */}
      <VideoPopup />

      <Header data={staticElementsQuery.data} pageDepartment={pageDepartment} />

      <main className={styles.main}>
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>

      <Footer data={staticElementsQuery.data} pageDepartment={pageDepartment} />

      <WhatsAppChat />
    </div>
  );
};
